// web/src/shell/PublicFooter.tsx
//
// Footer rendered on public-facing routes. Uses absolute apex URLs so
// it works the same in both the marketing build (where the browser
// navigates same-origin to the apex) and the app build (where the
// browser navigates cross-origin to apex, bypassing the SPA router
// and any removed in-app routes).
import { openCookieConsent } from "./CookieConsent";

const APEX = "https://tapelens.com";
const APP = "https://app.tapelens.com";

export function PublicFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border mt-12 px-4 py-10">
      <div className="mx-auto grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <h3 className="mb-3 text-sm font-semibold">Product</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`${APEX}/pricing`} className="text-muted-foreground hover:text-foreground">
                Pricing
              </a>
            </li>
            <li>
              <a href={`${APP}/auth/signup`} className="text-muted-foreground hover:text-foreground">
                Free trial
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold">Company</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`${APEX}/help`} className="text-muted-foreground hover:text-foreground">
                Help & FAQs
              </a>
            </li>
            <li>
              <a href={`${APEX}/contact-us`} className="text-muted-foreground hover:text-foreground">
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`${APEX}/legal/terms`} className="text-muted-foreground hover:text-foreground">
                Terms
              </a>
            </li>
            <li>
              <a href={`${APEX}/legal/privacy`} className="text-muted-foreground hover:text-foreground">
                Privacy
              </a>
            </li>
            <li>
              <a href={`${APEX}/legal/refund`} className="text-muted-foreground hover:text-foreground">
                Refund Policy
              </a>
            </li>
            <li>
              <button
                type="button"
                onClick={openCookieConsent}
                className="text-muted-foreground hover:text-foreground bg-transparent p-0 cursor-pointer"
              >
                Cookie preferences
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold">Get in touch</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="mailto:support@tapelens.com"
                className="text-muted-foreground hover:text-foreground"
              >
                support@tapelens.com
              </a>
            </li>
            <li>
              <a
                href="mailto:contact@tapelens.com"
                className="text-muted-foreground hover:text-foreground"
              >
                contact@tapelens.com
              </a>
            </li>
            <li>
              <a
                href="mailto:legal@tapelens.com"
                className="text-muted-foreground hover:text-foreground"
              >
                legal@tapelens.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-5xl border-t border-border pt-6 text-center text-xs text-muted-foreground">
        © {year} Tapelens · Tapelens is not investment advice. Markets carry risk; trade responsibly.
      </div>
    </footer>
  );
}
